export const PermissionOrganization = {
    DELETE: "delete_organization",
    PUT: "change_organization",
    POST: "add_organization",
    VIEW: "view_organization",
    EXPORT: "can_export_organization",
    IMPORT: "can_import_organization"
};